import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonComponent } from '@app/shared/button/button.component';
import { UtilService } from '@helpers/util.service';
import { NgxMaskModule, NgxMaskPipe } from 'ngx-mask';
import { CarouselModule } from 'primeng/carousel';
import { IHotOfferItem, INewBuilding } from '../home.component';
import { FavouritesManagementService } from '@modules/real-property-toolbar/services';
import { MessageService } from 'primeng/api';
import { RealPropertyService } from '@modules/real-property-details';
import { PrimeNgModule } from '@shared/modules/prime-ng/prime-ng.module';

@Component({
  selector: 'app-card-object',
  standalone: true,
  templateUrl: './card-object.component.html',
  styleUrls: ['./card-object.component.scss'],
  imports: [ButtonComponent, CommonModule, CarouselModule, NgxMaskModule, PrimeNgModule],
  providers: [NgxMaskPipe],
})
export class CardObjectComponent implements OnInit {
  @Input() isLiked = false;
  @Input() isHotOffer = false;
  @Input() isBurn = true;
  @Input() isShowPrice = false;
  @Input() isNewBuildings = false;
  @Input() isMobile: boolean;
  @Input() application: IHotOfferItem | INewBuilding | null = null;
  @Input() onlyImage: boolean;

  @Output() navigateToAgent = new EventEmitter();
  @Output() navigateToAnotherPageEvent = new EventEmitter();

  textButton = 'Показать телефон';
  isShowPhone = false;

  constructor(
    private _utilService: UtilService,
    private _mask: NgxMaskPipe,
    private _favoritesService: FavouritesManagementService,
    private _messageService: MessageService,
    private _realPropertyService: RealPropertyService,
  ) {}

  ngOnInit(): void {}

  toggleFavorite() {
    const favoriteAction = (this.application as any).isFavorite
      ? this._favoritesService.removeRealPropertyObjectFromFavouritesList((this.application as any).realPropertyId)
      : this._favoritesService.addRealPropertyObjectToFavourites((this.application as any).realPropertyId);
    this.application = { ...this.application, isFavorite: !(this.application as any).isFavorite };
    favoriteAction.subscribe((res: any) => {
      this._realPropertyService.updateRealProperty(this.application);
      if (typeof res !== 'number') {
        this._messageService.add({ severity: 'error', summary: 'Ошибка', detail: res });
      }
      return this.application;
    });
  }

  urlPhoto(photoUuid: string) {
    return this._utilService.getFilePath() + photoUuid;
  }

  showPhone() {
    this.isShowPhone = !this.isShowPhone;
    this.textButton = this.isShowPhone ? this._mask.transform('7' + '7057559595', '+0 000 000 00 00') : 'Показать телефон';
  }

  public onImageError(event: Event): void {
    (event.target as HTMLImageElement).classList.add('empty');
    (event.target as HTMLImageElement).src = 'assets/images/1x_no_image_and_video.png';
  }

  public onAvatarError(event: Event): void {
    (event.target as HTMLImageElement).src = 'assets/images/no_avatar.png';
  }

  public navigateToAgentPage(id: any): void {
    this.navigateToAgent.emit(id);
  }

  navigateToAnotherPage(id: number): void {
    this.navigateToAnotherPageEvent.emit(id);
  }

  isHotOfferItem(app: IHotOfferItem | INewBuilding | null): app is IHotOfferItem {
    return !!app && this.isHotOffer;
  }

  isNewBuilding(app: IHotOfferItem | INewBuilding | null): app is INewBuilding {
    return !!app && this.isNewBuildings;
  }
}
